export const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export const Roles = {
    CLIENT: 1,
    DEALER: 2,
    PORTTECHNICIAN: 3,
    PORTADMIN: 4,
    ADMINIT: 5,
}

const ROLENAMES = {
    [Roles.CLIENT]: '(Cliente)',
    [Roles.DEALER]: '(Concessionário)',
    [Roles.PORTTECHNICIAN]: '(Técnico de Porto)',
    [Roles.PORTADMIN]: '(Admin de Porto)',
    [Roles.ADMINIT]: '(Admin IT)',
}

export function getRoleNameById(userId) {
    return ROLENAMES[userId] || ''
}

export const PROFILES = [
    {
        value: Roles.CLIENT,
        label: 'Cliente'
    },
    {
        value: Roles.DEALER,
        label: 'Concessionário'
    },
    {
        value: Roles.PORTTECHNICIAN,
        label: 'Técnico de Porto'
    },
    {
        value: Roles.PORTADMIN,
        label: 'Admin de Porto'
    }
]

export const SKILLS = {
    fairingPutToDry: 1,
    fairingPutToSwim: 2,
    fairingLineChange: 3,
    electricitySupply: 4,
    accessToFacilities: 5,
    mooring: 6
}

export const SkillNames = {
    fairing: 'Querenagem',
    fairingEnergy: 'Querenagem + Energia',
    mooring: 'Acostagem',
    mooringEnergy: 'Acostagem + Energia',
    electricitySupply: 'Fornecimento de energia elétrica',
    accessToFacilities: 'Acesso às instalações'
}

export const STATES = [
    {
        value: 1,
        label: 'Ativo'
    },
    {
        value: 2,
        label: 'Inativo'
    }
]

export const ScheduleStatus = {
    INCHECK: 1,
    CONFIRMED: 2,
    REJECTED: 3,
    RESCHEDULE: 4
}

export const IVA = [
    {
        value: 23,
        label: '23%'
    },
    {
        value: 13,
        label: '13%'
    },
    {
        value: 6,
        label: '6%'
    }
]

export const ScheduleTypes = {
    FAIRING: 1,
    FAIRINGENERGY: 2,
    MOORING: 3,
    MOORINGENERGY: 4,
    ENERGY: 5,
    FACILITIES: 6
}

export const TIMES = [
    {
        value: 4,
        label: '04:00h'
    },
    {
        value: 4.5,
        label: '04:30h'
    },
    {
        value: 5,
        label: '05:00h'
    },
    {
        value: 5.5,
        label: '05:30h'
    },
    {
        value: 6,
        label: '06:00h'
    },
    {
        value: 6.5,
        label: '06:30h'
    },
    {
        value: 7,
        label: '07:00h'
    },
    {
        value: 7.5,
        label: '07:30h'
    },
    {
        value: 8,
        label: '08:00h'
    },
    {
        value: 8.5,
        label: '08:30h'
    },
    {
        value: 9,
        label: '09:00h'
    },
    {
        value: 9.5,
        label: '09:30h'
    },
    {
        value: 10,
        label: '10:00h'
    },
    {
        value: 10.5,
        label: '10:30h'
    },
    {
        value: 11,
        label: '11:00h'
    },
    {
        value: 11.5,
        label: '11:30h'
    },
    {
        value: 12,
        label: '12:00h'
    },
    {
        value: 12.5,
        label: '12:30h'
    },
    {
        value: 13,
        label: '13:00h'
    },
    {
        value: 13.5,
        label: '13:30h'
    },
    {
        value: 14,
        label: '14:00h'
    },
    {
        value: 14.5,
        label: '14:30h'
    },
    {
        value: 15,
        label: '15:00h'
    },
    {
        value: 15.5,
        label: '15:30h'
    },
    {
        value: 16,
        label: '16:00h'
    },
    {
        value: 16.5,
        label: '16:30h'
    },
    {
        value: 17,
        label: '17:00h'
    },
    {
        value: 17.5,
        label: '17:30h'
    },
    {
        value: 18,
        label: '18:00h'
    },
    {
        value: 18.5,
        label: '18:30h'
    },
    {
        value: 19,
        label: '19:00h'
    },
    {
        value: 19.5,
        label: '19:30h'
    },
    {
        value: 20,
        label: '20:00h'
    },
    {
        value: 20.5,
        label: '20:30h'
    },
    {
        value: 21,
        label: '21:00h'
    },
    {
        value: 21.5,
        label: '21:30h'
    },
    {
        value: 22,
        label: '22:00h'
    },
    {
        value: 22.5,
        label: '22:30h'
    },
    {
        value: 23,
        label: '23:00h'
    }
]

export const EQUIPMENTS = {
    travelLift: 1,
    agriculturalTractor: 2,
    automobileCrane5T: 3,
    automobileCrane10T: 4
}